import { useEffect, useState } from 'react';

/**
 * 値の変化が落ち着くまで反映を遅らせる。
 *
 * 検索ボックスの入力をそのままクエリキーにすると、1 文字打つごとに fetch が走り
 * 一覧全体が再描画される。入力自体は即時に反映しつつ（`value` はそのまま表示に使う）、
 * 通信のトリガーになる値だけをここで遅らせる。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business 入力が落ち着くまで値の反映を遅らせ、打鍵ごとの再取得を防ぐ
 * @graph-connects none
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delayMs);
    // 次の入力が来たら前回のタイマーを捨てる。捨てないと打鍵ごとに反映が走る
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return debounced;
}
